module.exports = __webpack_public_path__ + "img/UI2.8f0c5a98.gif";